import { Mixins, Component, Prop } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'

@Component({
    inheritAttrs: false,
    name: 'Permissions',
})
export default class Permissions extends Mixins<MixinInterface>() {
    @Prop({ required: true }) permissionGroups!: any
    @Prop({ required: true }) grouppedPermissions!: any
    @Prop({ default: true, type: Boolean }) showHeaderTitle!: boolean

    permissionPanel: Array<number> = []

    togglePermissionGroups() {
        if (this.permissionPanel.length === 0) {
            this.permissionPanel = this.permissionGroups.map((_, i) => i)
        } else {
            this.permissionPanel = []
        }
    }
}
